import { get } from 'lodash'
import { required } from 'utils/validation'


export const asyncValidate = (values, dispatch, props) => {
  let errors = {}

  const defaultResponse = { body: { value: false } }

  const id = get(props, 'profile.data.id') || get(props, 'id')

  const promises =  id && Promise.all([ props.checkPasswordEmail(id, get(values, 'newPassword'))])

  return promises && promises.catch(() => defaultResponse).then(r => {

      const body = get(r[0], 'body')

      if(!get(body, 'isValid')){
        errors = {
          ...errors,
          newPasswordAgain: {
            text: 'The password has already been used in the past.',
            intlKey: 'errors.password_has_already_been_used_in_the_past'
          }
        }

        throw errors
      }
    })


}

export const validate = values => {
  let errors = {}

  errors = {
    currentPassword: required(get(values, 'currentPassword')),
    newPasswordAgain: required(get(values, 'newPasswordAgain'))
  }

  if (get(values, 'newPassword') && get(values, 'newPasswordAgain')) {
    if (get(values, 'newPassword') !== get(values, 'newPasswordAgain')) {
      errors = {
        ...errors,
        newPasswordAgain: {
          text: 'Passwords don\'t match',
          intlKey: 'errors.passwords_dont_match',
          values: {}
        }
      }
    }
  }

  return errors
}

export default validate
